import styles from './index.module.css'
import { useParams } from 'react-router-dom';
import ImageDetail from './components/ImageDetail'
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { actionCreators } from './store';


function Detail() {
    const dispatch = useDispatch()
    const { id } = useParams();
    const [imageData, setImageData] = useState(null); // 用于存储图片详细信息
    const [loading, setLoading] = useState(true); // 用于表示数据是否正在加载
    const [error, setError] = useState(null); // 用于存储错误信息

    useEffect(() => {
        if (id) {
            dispatch(actionCreators.imageSearchGet(id))
                .then((data) => {
                    setImageData(data); // 将获取到的图片详细信息存储到状态中
                })
                .catch((err) => {
                    setError(err.message)
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [id])

    return (
        <div className={styles.container}>
            <ImageDetail
                imageData={imageData}
                loading={loading}
                error={error}
            />
        </div>
    )
}

export default Detail